(() => {
  const getData = (node, key) => node?.dataset?.[key];

  const getSlidesPerView = (section) => {
    const isMobile = window.matchMedia("(max-width: 575px)").matches;
    const columnsPerRow = Number(getData(section, "columnsPerRow")) || 1;
    const columnsMobile = Number(getData(section, "columnsMobile")) || 1;
    const baseSlidesPerView = isMobile ? columnsMobile : columnsPerRow;
    const showPartialSlide = getData(section, "partialSlide") === "true";
    return showPartialSlide ? baseSlidesPerView + 0.2 : baseSlidesPerView;
  };

  const buildSwiperOptions = (section) => {
    const options = {
      slidesPerView: getSlidesPerView(section),
      loop: false,
      spaceBetween: 16,
      autoHeight: false,
      calculateHeight: false,
      keyboard: true,
    };

    const scrollbarEl = section.querySelector(".card-list__scrollbar");
    if (scrollbarEl) {
      options.scrollbar = {
        el: scrollbarEl,
        draggable: true,
      };
    }

    return options;
  };

  const initSwiper = (section) => {
    const sectionId = section.id;
    const swiperContainer = section.querySelector(".swiper");

    if (!swiperContainer || swiperContainer.swiperInitialized) return;

    swiperContainer.swiperInstance = new Swiper(`#${sectionId} .swiper`, buildSwiperOptions(section));
    swiperContainer.swiperInitialized = true;
  };

  const destroySwiper = (section) => {
    const swiperContainer = section.querySelector(".swiper");
    const instance = swiperContainer?.swiperInstance;

    if (!instance) return;

    try {
      instance.destroy(true, true);
    } catch (error) {
      // noop
    }

    delete swiperContainer.swiperInstance;
    delete swiperContainer.swiperInitialized;
  };

  const updateSection = (section) => {
    destroySwiper(section);
    initSwiper(section);
  };

  const updateAllSections = () => {
    document.querySelectorAll(".card-list-section").forEach(updateSection);
  };

  document.addEventListener("DOMContentLoaded", () => {
    updateAllSections();
    window.addEventListener("resize", updateAllSections, { passive: true });
    document.addEventListener("shopify:section:load", updateAllSections);
  });
})();